import {
  ADMIN_SYSTEM_PROBLEMS,
  AdminHeader,
  Div,
  handleSetUrlSearchParams,
  Tab,
  TabsWrapper,
  useAuth,
  UserRole,
} from '@vgrubs/components';
import { Navigate, useSearchParams } from 'react-router-dom';
import { DashboardTabRow } from './DashboardTabs.styled';
import { DeliveriesSection } from './sections/DeliveriesSection/DeliveriesSection';
import { FinancesSection } from './sections/FinancesSection/FinancesSection';
import { OrdersSection } from './sections/OrdersSection/OrdersSection';

enum Tabs {
  Orders = 'orders',
  Deliveries = 'deliveries',
  Finances = 'finances',
}

export const Dashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || Tabs.Orders;

  const setTab = (tab: Tabs) => {
    handleSetUrlSearchParams('tab', tab, setSearchParams);
  };

  const { user } = useAuth();

  const actions = [
    {
      value: Tabs.Orders,
      label: 'Orders',
      onClick: () => setTab(Tabs.Orders),
    },
    {
      value: Tabs.Deliveries,
      label: 'Deliveries',
      onClick: () => setTab(Tabs.Deliveries),
    },

    {
      value: Tabs.Finances,
      label:
        user?.role !== UserRole.support ? 'Finances' : 'Profit & Loss Insights',
      onClick: () => setTab(Tabs.Finances),
      disabled:
        user?.role !== UserRole.admin && user?.role !== UserRole.support,
    },
  ];

  const visibleTabs = actions
    .filter((action) => !action.disabled)
    .map((action) => (
      <Tab
        selected={tab === action.value}
        key={action.value}
        onClick={action.onClick}
      >
        {action.label}
      </Tab>
    ));

  /* System Problems was a tab here before it got its own page; links and
     pushes sent with `?tab=problems` still land, filters and all. */
  if (tab === 'problems') {
    const rest = new URLSearchParams(searchParams);
    rest.delete('tab');
    const query = rest.toString();
    return (
      <Navigate
        replace
        to={`${ADMIN_SYSTEM_PROBLEMS}${query ? `?${query}` : ''}`}
      />
    );
  }

  return (
    <>
      <AdminHeader title={`Dashboard`}>
        <Div $desktop>
          <DashboardTabRow>{visibleTabs}</DashboardTabRow>
        </Div>
      </AdminHeader>
      {/* One row that scrolls sideways on a phone, like Verifications and
          every other tab row in the admin. The negative margin cancels the
          20px top margin every section opens with (the two collapse), so the
          wrapper's own bottom padding - room for the selected tab's shadow -
          is the whole gap. */}
      <Div $mobile>
        <TabsWrapper style={{ marginBottom: -20 }}>{visibleTabs}</TabsWrapper>
      </Div>

      {tab === Tabs.Orders && <OrdersSection />}
      {tab === Tabs.Deliveries && <DeliveriesSection />}
      {tab === Tabs.Finances && <FinancesSection />}
    </>
  );
};
